export enum OperationTypeEnum {
    GRN = 'GRN',
    BE_HEADING = 'DEHEADING',
    GRADING = 'GRADING',
    VALUE_ADDITION = 'VALUE ADDITION',
    SOAKING = 'SOAKING',
    FREEZING = 'FREEZING',
    PACKING = 'PACKING',
    NO_OPERATION = 'NO OPERATION',
    TOFF = 'TOFF',
    PD = 'PD',
    RPDTON = 'RPDTON',
    COOKING='COOKING',
    PEELING='PEELING',
    PEELUNDEVEIN = 'PEELUNDEVEIN',
    REJECTION = 'REJECTION',
    DEGUMMING = 'DEGUMMING',
    OPENING='OPENING', //thia
    CARDING='CARDING',
    DRAWING='DRAWING',
    COMBING='COMBING',
    PASSAGE='PASSAGE',
    DRESSING='DRESSING', //thia
    PICKING='PICKING',
    SPREADER='SPREADER',
    SIMPLEX='SIMPLEX',
    RING_FRAME='RING FRAME',
    DOUBLING='DOUBLING',
    AUTO_CONER='AUTO CONER',
    GASING='GASING',
    CONEWINDING='CONEWINDING',
    REELING='REELING',
    BLOWROOM='BLOWROOM',
    FLAT_CARDING='FLAT CARDING',
    OPEN_END='OPEN END',
    A1='A1',
    B2='B2',
    C3='C3',
    SET_FRAME='SET FRAME',
    CLUBBING = 'CLUBBING',
     CARDING_C1='CARDING_C1/3'


}

export const OpertionTypeDropDown = [
    {name : 'GRN',value:'GRN'},{name : 'DEHEADING',value:'DEHEADING'},{name:'GRADING',value:'GRADING'},{name : 'VALUE ADDITION',value:'VALUE_ADDITION'},{name:'SOAKING',value:'SOAKING'},{name:'FREEZING',value:'FREEZING'},{name:'PACKING',value:'PACKING'},{name:'NO OPERATION',value:'NO_OPERATION'},{name:'TOFF',value:'TOFF'},{name:'PD',value:'PD'},{name:'RPDTON',value:'RPDTON'},
    {name:'COOKING',value:'COOKING'},{name:'PEELING',value:'PEELING'},{name:'PEELUNDEVEIN',value:'PEELUNDEVEIN'},{name:'REJECTION',value:'REJECTION'}
]

export enum OperationTypeDropDownEnum {
    
    BE_HEADING = 'DEHEADING',
    VALUE_ADDITION = 'VALUE ADDITION',


}

export enum operationEntryTypeEnum{
    IN='IN',
    OUT='OUT'
}

export enum countTypeEnum{
    SINGLE='SINGLE',
    DOUBLE='DOUBLE'
}


export enum spsaOperationEnum{
    OPENING='OPENING', //thia
    CARDING='CARDING',
    DRAWING='DRAWING',
    COMBING='COMBING',
    PASSAGE='PASSAGE',
    DRESSING='DRESSING', //thia
    PICKING='PICKING',
    SPREADER='SPREADER',
    SIMPLEX='SIMPLEX',
    RING_FRAME='RING FRAME',
    DOUBLING='DOUBLING',
    AUTO_CONER='AUTO CONER',
    GASING='GASING',
    CONEWINDING='CONEWINDING',
    REELING='REELING',
    BLOWROOM='BLOWROOM',
    FLAT_CARDING='FLAT CARDING',
    OPEN_END='OPEN END',
    A1='A1',
    B2='B2',
    C3='C3',
    SET_FRAME='SET FRAME',
     PACKING = 'PACKING',
    CLUBBING = 'CLUBBING',
    CARDING_C1='CARDING_C1/3'

}

export enum spsaPrevOperationEnum{
    DEGUMMING = 'DEGUMMING',
    OPENING='OPENING', //thia
    CARDING='CARDING',
    DRAWING='DRAWING',
    COMBING='COMBING',
    PASSAGE='PASSAGE',
    DRESSING='DRESSING', //thia
    PICKING='PICKING',
    SPREADER='SPREADER',
    SIMPLEX='SIMPLEX',
    RING_FRAME='RING FRAME',
    DOUBLING='DOUBLING',
    AUTO_CONER='AUTO CONER',
    GASING='GASING',
    CONEWINDING='CONEWINDING',
    REELING='REELING',
    BLOWROOM='BLOWROOM',
    FLAT_CARDING='FLAT CARDING',
    OPEN_END='OPEN END',
    A1='A1',
    B2='B2',
    C3='C3',
    SET_FRAME='SET FRAME',
    PACKING = 'PACKING',
    CLUBBING = 'CLUBBING',
    CARDING_C1='CARDING_C1/3'

}